import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialog  } from './confirm-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentesService } from '../componentes.service';
import { FechaModule } from '../fecha';
import { UtilsModule } from '@tres-erres/ngx-utils';

@NgModule({
	declarations: [
		ConfirmDialog,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSnackBarModule,
		MatIconModule,
		MatTooltipModule,
		FechaModule,
		UtilsModule
	],
	exports: [
		ConfirmDialog
	],
	entryComponents: [ConfirmDialog],
})
export class ConfirmDialogModule { }
